// custom CSS styles
import "./src/style.css"

// Highlighting for code blocks
import "prismjs/themes/prism-tomorrow.css"
import "prismjs/plugins/line-numbers/prism-line-numbers.css"

import { isAppPage } from "./src/app-pages"

// Keep the app-page body class in sync during client-side navigation
// (gatsby-ssr sets it for the initial server-rendered HTML)
export const onRouteUpdate = ({ location }) => {
  document.body.classList.toggle("app-page", isAppPage(location.pathname))
}
